document.addEventListener('DOMContentLoaded', async function () {
  const stickerVariantId = 45949428990150;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const hasSticker = cart.items.some(item =>
      item.variant_id === 45949428990150 ||
      item.variant_id === 45949429022918
    );

    const hasOtherProducts = cart.items.some(item =>
      item.variant_id !== 45949428990150 &&
      item.variant_id !== 45949429022918
    );

    if (hasOtherProducts && !hasSticker) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: stickerVariantId,
          quantity: 1
        })
      });

      window.location.reload();
    }
  } catch (e) {
    console.log('Free sticker error:', e);
  }
});